import Section from '~/src/features/tariffBuilder/components/Section';
import ContactsContainer from '~/src/features/tariffBuilder/containers/ContactsContainer';

// Switching to the next step is implemented in the ContactsContainer
const FillContacts = (): JSX.Element => {
    return (
        <Section>
            <ContactsContainer />
        </Section>
    );
};

export default FillContacts;
